import CryptoJS from 'crypto-js'
import api from '../../../store/api';

export const encrypt = (store, user, patient) => {
  if(patient) {
    let securityPin = user.getSecurityPin();
    let serverKey = user.getServerKey();
    try {
      if (encryptionSafe(securityPin, serverKey)) {
        const key = `${serverKey}${securityPin}`
        patient.name = CryptoJS.AES.encrypt(patient.name, key).toString()
        patient.surname = CryptoJS.AES.encrypt(patient.surname, key).toString()
        patient.phone = patient.phone ? CryptoJS.AES.encrypt(patient.phone, key).toString() : null
        patient.email = patient.email ? CryptoJS.AES.encrypt(patient.email, key).toString() : null
        patient.birthNumber = CryptoJS.AES.encrypt(patient.birthNumber, key).toString()
        patient.isClientEncrypted = true
        if (Array.isArray(patient.patientAddress) && patient.patientAddress.length > 0) {
          patient.patientAddress.forEach(address => {
            if (address.encrypted) {
              address.city = address.city ? CryptoJS.AES.encrypt(address.city, key).toString() : null
              address.street = address.street ? CryptoJS.AES.encrypt(address.street, key).toString() : null
              address.zip = address.zip ? CryptoJS.AES.encrypt(address.zip, key).toString() : null
              address.isClientEncrypted = true
            }
          })
        }
      }
      if(patient.name.indexOf('U2F') !== 0 || patient.name.length === 0) {
        throw 'Malformed input';
      }
      return patient
    } catch (e) {
      let secPin = securityPin ? 'string('+securityPin.toString().length+')' : 'null';
      api.post('log-events/log', {'name':'patient.encryptFailed','context':'patientId:'+patient.id+';serverKey:'+serverKey+';pin:'+secPin+';message:'+e.message});
      return patient;
    }
  }
}

export const decrypt = (store, user, patient) => {
  if (false === patient.isClientEncrypted) {
    return patient
  }
  let serverKey = user.getServerKey();
  let securityPin = user.getSecurityPin();
  //securityPin = 123;
  try {
    if (encryptionSafe(securityPin, serverKey)) {
      const key = `${serverKey}${securityPin}`

      patient.name = CryptoJS.AES.decrypt(patient.name, key).toString(CryptoJS.enc.Utf8)
      patient.surname = CryptoJS.AES.decrypt(patient.surname, key).toString(CryptoJS.enc.Utf8)
      patient.phone = patient.phone ? CryptoJS.AES.decrypt(patient.phone, key).toString(CryptoJS.enc.Utf8) : null
      patient.email = patient.email ? CryptoJS.AES.decrypt(patient.email, key).toString(CryptoJS.enc.Utf8) : null
      patient.birthNumber = CryptoJS.AES.decrypt(patient.birthNumber, key).toString(CryptoJS.enc.Utf8)

      patient.fullName = `${patient.titlePrefix || ''} ${patient.name} ${patient.surname} ${patient.titleSufix || ''}`.trim()
      patient.fullNameSurnameFirst = `${patient.titlePrefix || ''} ${patient.surname} ${patient.name} ${patient.titleSufix || ''}`.trim()
      patient.fullNameWithBirthNumber = `${patient.fullName} (${patient.birthNumber})`.trim()
      patient.fullNameSurnameFirstWithBirthNumber = `${patient.fullNameSurnameFirst} (${patient.birthNumber})`.trim()
      if (Array.isArray(patient.patientAddress) && patient.patientAddress.length > 0) {
        patient.patientAddress.forEach(address => {
          if (address.isClientEncrypted) {
            address.city = address.city ? CryptoJS.AES.decrypt(address.city, key).toString(CryptoJS.enc.Utf8) : null
            address.street = address.street ? CryptoJS.AES.decrypt(address.street, key).toString(CryptoJS.enc.Utf8) : null
            address.zip = address.zip ? CryptoJS.AES.decrypt(address.zip, key).toString(CryptoJS.enc.Utf8) : null
          }
        })
      }
    }
    if(patient.name.indexOf('U2F') === 0 || patient.name.length === 0) {
       throw 'Malformed output';
    }
  } catch (e) {
    let secPin = securityPin ? 'string('+securityPin.toString().length+')' : 'null';
    api.post('log-events/log', {'name':'patient.decryptFailed','context':'patientId:'+patient.id+';serverKey:'+serverKey+';pin:'+secPin+';message:'+e});
  }
  return patient
}

export const encryptionSafe = (pin, serverKey) => {
  if (pin && serverKey) {
    const fullKey = `${serverKey}${pin}`;
    const testText = '+ěščřžýáíé=´)ú¨;123456789';
    try {
      let encryptedText = CryptoJS.AES.encrypt(testText, fullKey).toString();
      let decryptedText = CryptoJS.AES.decrypt(encryptedText, fullKey).toString(CryptoJS.enc.Utf8);
      if (decryptedText === testText) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  } else {
    return false;
  }
}

export const patientResponseValid = (response) => {
  if (typeof response === 'object'
    && response.hasOwnProperty('status')
    && response.status === 200
    && response.hasOwnProperty('data')
    && typeof response.data === 'object'
    && response.data.hasOwnProperty('id')
    && response.data.id > 0
    && response.data.hasOwnProperty('isClientEncrypted')
    && response.data.isClientEncrypted
  ) {
    return true;
  } else {
    return false;
  }
}

/**
 * Encrypt all existing patients/addresses
 * @param store
 * @returns {Promise<unknown>}
 */
export const encryptBackdata = (user, store) => {
  return new Promise((resolve, reject) => {
    if (user.getAccountData().backdataEncrypted === false) {
      let serverKey = user.getServerKey();
      let securityPin = user.getSecurityPin();
      if (encryptionSafe(securityPin, serverKey)) {
        api.get('css/get-patients').then(response => {
          let encPatients = [];
          response.data.forEach(patient => {
            if (patient.encrypted && !patient.isClientEncrypted) {
              let patientCopy = JSON.parse(JSON.stringify(patient));
              patientCopy = encrypt(store,user, patientCopy)
              encPatients.push(patientCopy);
            }
          });
          return encPatients;
        }).then((patients) => {
          api.post('css/save-patients', patients).then((response) => {
            resolve(true);
          });
        });
      } else {
        resolve(false);
      }
    } else {
      resolve(true);
    }
  });
}

export const decryptAttachment = (store, user, attachment) => {
  if (false === attachment.isClientEncrypted) {
    return attachment;
  }
  attachment.decryptedFilename = decryptValue(user, attachment.encryptedFilename)
  attachment.link = decryptValue(user, attachment.content)
  return attachment
}

export const encryptValue = (store, user, content) => {
  let serverKey = user.getServerKey();
  let securityPin = user.getSecurityPin();
  const key = `${serverKey}${securityPin}`
  return CryptoJS.AES.encrypt(content, key).toString()
}

export const decryptValue = (user, content) => {
  let serverKey = user.getServerKey();
  let securityPin = user.getSecurityPin();
  const key = `${serverKey}${securityPin}`
  return CryptoJS.AES.decrypt(content, key).toString(CryptoJS.enc.Utf8)
}



// WEBPACK FOOTER //
// ./src/pages/private/patients/helper.js